import React, { useState } from 'react';
import { motion } from 'framer-motion';
import CloseIcon from '@mui/icons-material/CloseRounded';

import { slideUp } from '../utils';
import styles from './ToEditCard.module.css';

const ToEditCard = ({ handleClose, initialValue, onValueChange }) => {
  const [to, setTo] = useState(initialValue);

  const handleChange = (e) => {
    setTo(e.target.value);
  };

  const handleSubmit = () => {
    const trimmed = to.trim();
    if (trimmed) {
      onValueChange(trimmed);
    } else {
      onValueChange('');
    }
    handleClose();
  };

  return (
    <motion.div
      onClick={(e) => e.stopPropagation()}
      className={styles['edit-card']}
      variants={slideUp}
      initial='hidden'
      animate='visible'
      exit='exit'
      onAnimationStart={(definition) => {
        if (definition === 'visible') {
          window.scrollTo(0, 0);
          document.body.style.overflow = 'hidden';
        }
      }}
    >
      <CloseIcon
        className={styles['close-button']}
        fontSize='large'
        onClick={handleClose}
      />
      <div className={styles['content-container']}>
        <h1 className={styles['header-text']}>Edit Recipient's Name</h1>
        <input
          className={styles['input-field']}
          type='text'
          value={to}
          onChange={handleChange}
          maxLength='50'
          placeholder="Type recipient's name..."
        />
      </div>
      <button className={`rounded-pill ${styles['save-button']}`} onClick={handleSubmit}>
        Save
      </button>
    </motion.div>
  );
};

export default ToEditCard;
